import type { EbookClient } from './ebooks';

export function textbookProgress(item: Awaited<ReturnType<EbookClient['list']>>[number]) {
  const progress = item.authoringProgress;
  return {
    percentage: progress?.totalCount
      ? ((progress.arrangedCount / progress.totalCount) * 100).toFixed(1)
      : null,
    count: !progress
      ? '进度暂未同步'
      : progress.totalCount
        ? `已编排 ${progress.arrangedCount} / ${progress.totalCount} 题`
        : `已编排 ${progress.arrangedCount} 题`,
    totalMissing: !!progress && progress.totalCount === null,
  };
}
